export function analyzeChapterChanges(oldContent = "", newContent = ""): boolean {
  const normalizeContent = (content: string): string => {
    return content

      .replace(/<\/?u>/g, "")

      .replace(/\s+/g, "")

      .replace(/[#*_`~>|-]/g, "")

      .replace(/<[^>]*>/g, "")

      .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1")
      .replace(/!\[([^\]]*)\]\([^)]+\)/g, "$1")

      .replace(/```[a-zA-Z0-9]*|```/g, "")

      .replace(/&[a-zA-Z0-9]+;/g, "")

      .toLowerCase();
  };

  const normalizedOld = normalizeContent(oldContent);
  const normalizedNew = normalizeContent(newContent);

  return normalizedOld !== normalizedNew;
}
